import classNames from "classnames";
import getDistance from "geolib/es/getDistance";
import math from "mathjs";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import LeafRating from "../../common/LeafRating";
import { getLeafRating } from "../../../util/leafRating";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { slugify } from "../../../util/slugify";
import "../../../App.css";
import "../../../Carousel.css";
import { updateMapCenter } from "../../../actions/currentLocation";
import {
  deleteRestaurant,
  hoverRestaurant,
  selectRestaurantFromList,
  unhoverRestaurant,
  unselectRestaurant,
} from "../../../actions/restaurants";
import {
  getAnalyticsSource,
  logRestaurantDetailsClick,
  logRestaurantOptionsScroll,
} from "../../../util/analytics";
import useEvent from "../../../hooks/useEvent";
import ResultTitleFrame, { Column } from "./ResultTitleFrame";
import RestaurantActionMenu from "./RestaurantActionMenu";
import {
  FlexBetween,
  RightContent as BaseRightContent,
} from "../../../styles/styled-components-utils";
import {
  CarouselSectionLabel,
  getDisplayableMenuItems,
} from "../../shared/MenuDisplay";
import HighlightText from "../../shared/HighlightText";
import ImageLightbox from "../../shared/ImageLightbox";

// Helper to extract section name (handles both subdocument and legacy string format)
const getSectionName = (section) => {
  if (!section) return null;
  if (typeof section === 'string') return section;
  return section.name || null;
};

const LeftContent = styled.div``;

const RightContent = styled(BaseRightContent)`
  min-width: 6em;
`;
const RestaurantResult = ({
  restaurant,
  hoverRestaurant,
  unhoverRestaurant,
  selectRestaurantFromList,
  unselectRestaurant,
  currentLocation,
  selected,
  selectedSource,
  token,
  updateMapCenter,
  isOpen,
  collapseSheet,
  searchQuery,
}) => {
  // Mobile detection for "See on map" button
  const isMobile = typeof window !== "undefined" && window.innerWidth < 600;
  const eventContext = useEvent();
  const [lightbox, setLightbox] = useState(null);
  const onMouseEnter = () => {
    hoverRestaurant(restaurant._id);
  };
  const onMouseLeave = () => {
    unhoverRestaurant();
  };
  const thisRef = useRef(null);
  const carouselInitializedRef = useRef(false);
  useEffect(function scrollIntoViewWhenSelectedFromMap() {
    if (selected && selectedSource === "MAP") {
      // thisRef.current.scrollIntoView({
      //   behavior: "smooth",
      //   block: "center",
      //   inline: "center",
      // });
      const mediaQuery = window.matchMedia("(max-width: 599px)");

      if (mediaQuery.matches) {
        // The viewport is 600px or less
        window.scrollTo({
          top: thisRef.current.offsetTop - 50,
          behavior: "smooth",
        });
      } else {
        // The viewport is more than 600px
        thisRef.current.parentNode.parentNode.scrollTop =
          thisRef.current.offsetTop - 50;
      }
    }
  }, [selected, selectedSource]);
  const distanceInMeters = getDistance(
    currentLocation,
    restaurant.geoJson.coordinates
  );
  const distance = math.unit(distanceInMeters, "m").to("mi");

  const onClick = selected
    ? () => {
        // unselectRestaurant();
        //  updateMapCenter(currentLocation)
      }
    : () => {
        // Pass eventContext to action, which will handle analytics logging
        selectRestaurantFromList(restaurant._id, eventContext, getAnalyticsSource(restaurant));
        updateMapCenter({
          lat: restaurant.geoJson.coordinates[1],
          lng: restaurant.geoJson.coordinates[0],
        });
      };

  const getOptionsCarousel = (restaurant) => {
    // Use displayable items which prefers allMenuItems (has sections) over veganOptions
    const displayItems = getDisplayableMenuItems(restaurant);

    if (displayItems.length === 0) {
      return null;
    }

    if (displayItems.length === 1) {
      const option = displayItems[0];
      return (
        <Column className={"result-option"} key={option._id || 0}>
          <div className="text-ellipsis-max-height">
            {getSectionName(option.section) && (
              <CarouselSectionLabel>{getSectionName(option.section)}</CarouselSectionLabel>
            )}
            <HighlightText text={option.option} query={searchQuery} />
            {option.description && (
              <span className="text-normal-weight text-ellipsis-max-height">
                : <HighlightText text={option.description} query={searchQuery} />
              </span>
            )}
          </div>
        </Column>
      );
    } else {
      const frames = [
        <ResultTitleFrame
          key={"123"}
          textArray={displayItems.map((option) => option.option)}
          searchQuery={searchQuery}
          detailsLink={
            <Link
              className={`${selected ? "" : "none"}`}
              to={{
                pathname: `/details/${restaurant._id}/${slugify(restaurant.name)}`,
                search: searchQuery ? `?keywords=${encodeURIComponent(searchQuery)}` : "",
              }}
              onClick={(e) => {
                // Stop event propagation to prevent parent onClick from firing
                e.stopPropagation();
                // Log restaurant details click when navigating to details page
                logRestaurantDetailsClick(restaurant._id, eventContext, getAnalyticsSource(restaurant));
              }}
            >
              rest of menu
            </Link>
          }
        />,
        ...displayItems
          .filter(
            (option) => (option.description && option.description.trim() !== "") || option.imageUrl
          )
          .slice(0, 6)
          .map((option, index) => (
            <Column className={"result-option"} key={option._id || index}>
              <div className="text-ellipsis result-option-padding" style={option.imageUrl ? { display: 'flex', gap: '10px', alignItems: 'flex-start' } : undefined}>
                {option.imageUrl && (
                  <img
                    src={option.imageUrl}
                    alt={option.option}
                    loading="lazy"
                    onClick={(e) => {
                      e.stopPropagation();
                      setLightbox({ imageUrl: option.imageUrl, name: option.option });
                    }}
                    style={{
                      width: 80, height: 80, borderRadius: 6,
                      objectFit: 'cover', flexShrink: 0, cursor: 'pointer',
                      pointerEvents: 'auto',
                    }}
                  />
                )}
                <div style={option.imageUrl ? { flex: 1, minWidth: 0 } : undefined}>
                  {getSectionName(option.section) && (
                    <CarouselSectionLabel>{getSectionName(option.section)}</CarouselSectionLabel>
                  )}
                  <HighlightText text={option.option} query={searchQuery} />
                  {option.description && (
                    <span className="text-normal-weight">
                      : <HighlightText text={option.description} query={searchQuery} />
                    </span>
                  )}
                </div>
              </div>
            </Column>
          )),
      ];
      if (frames.length > 1) {
        return (
          <Carousel
            className={"custom"}
            showThumbs={false}
            showStatus={false}
            swipeable={false}
            onChange={(index) => {
              // Log restaurant options scroll when navigating through carousel
              // Skip initial render (index 0 on first mount)
              if (!carouselInitializedRef.current) {
                carouselInitializedRef.current = true;
                return;
              }
              // Only log when user actually navigates (not initial render)
              logRestaurantOptionsScroll(restaurant._id, eventContext);
            }}
          >
            {frames}
          </Carousel>
        );
      } else {
        return frames[0];
      }
    }
  };
  return (
    <>
    <div
      className={`result-row ${isOpen ? "" : "none"}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      key={restaurant._id}
      ref={thisRef}
    >
      <FlexBetween
        restaurant={restaurant}
        key={restaurant._id}
        className={classNames("result", { selected: selected })}
        ref={thisRef}
      >
        <LeftContent>
          {" "}
          {restaurant.metadata?.adHocSearch ? "✨ " : ""}
          {restaurant.name}
          <div className="result-body">
            {restaurant.cuisine && restaurant.cuisine.filter(Boolean).length > 0
              ? restaurant.cuisine
                  .filter(Boolean)
                  .map((string) => string.replace(/\b\w/g, (l) => l.toUpperCase()))
                  .join(", ")
              : ""}
          </div>
        </LeftContent>

        <RightContent>
          {" "}
          {token && (
            <div className="admin-option">
              <RestaurantActionMenu
                restaurant={restaurant}
                token={token}
              />
            </div>
          )}
{!eventContext?.event && (() => {
            const leafRating = getLeafRating(restaurant);
            return <LeafRating count={leafRating.count} tier={leafRating.tier} />;
          })()}
          <br />
          {math.format(distance, { notation: "fixed", precision: 2 })}
        </RightContent>
      </FlexBetween>
      <div className={`selected result-body ${selected ? "" : "none"}`}>
        {getOptionsCarousel(restaurant)}
      </div>
      <div
        className={selected ? "selected" : ""}
        style={{ fontSize: ".5em", flexBasis: "100%", flexGrow: 1 }}
      >
        {selected ? "" : "See more"}
      </div>
      {restaurant.metadata?.adHocSearch ? (
        <Link
          className={`${selected ? "" : "none"}`}
          to="/ad-hoc/details"
          state={{ restaurant }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          View Full Details
        </Link>
      ) : (
        <Link
          className={`${selected ? "" : "none"}`}
          to={{
            pathname: `/details/${restaurant._id}/${slugify(restaurant.name)}`,
            search: searchQuery ? `?keywords=${encodeURIComponent(searchQuery)}` : "",
          }}
          onClick={(e) => {
            // Stop event propagation to prevent parent onClick from firing
            e.stopPropagation();
            // Log restaurant details click when navigating to details page
            logRestaurantDetailsClick(restaurant._id, eventContext, getAnalyticsSource(restaurant));
          }}
        >
          see details
        </Link>
      )}
      {/* "See on map" button for mobile bottom sheet */}
      {isMobile && selected && collapseSheet && (
        <button
          className="see-on-map-btn"
          onClick={(e) => {
            e.stopPropagation();
            collapseSheet();
            selectRestaurantFromList(restaurant._id, eventContext, getAnalyticsSource(restaurant));
            updateMapCenter({
              lat: restaurant.geoJson.coordinates[1],
              lng: restaurant.geoJson.coordinates[0],
            });
          }}
        >
          <i className="fas fa-map-marker-alt" /> See on map
        </button>
      )}
    </div>
    {lightbox && (
      <ImageLightbox
        imageUrl={lightbox.imageUrl}
        name={lightbox.name}
        onClose={() => setLightbox(null)}
      />
    )}
    </>
  );
};

RestaurantResult.propTypes = {
  currentLocation: PropTypes.object.isRequired,
};
const mapStateToProps = (state, props) => ({
  currentLocation: state.currentLocation,
  selected: state.restaurant.selected === props.restaurant._id,
  selectedSource: state.restaurant.source,
  token: state.auth.token,
});
export default connect(mapStateToProps, {
  hoverRestaurant,
  unhoverRestaurant,
  selectRestaurantFromList,
  unselectRestaurant,
  deleteRestaurant,
  updateMapCenter,
})(RestaurantResult);
